interface ImageGalleryProps {
  images: string[];
  productName: string;
}

export default function ImageGallery({ images, productName }: ImageGalleryProps) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [zoomed, setZoomed] = useState(false);

  const mainImage = images[selectedIndex] || images[0];

  return (
    <div className="space-y-3">
      {/* Main image */}
      <div
        className="relative aspect-square rounded-2xl overflow-hidden bg-secondary-100 cursor-zoom-in group"
        onClick={() => setZoomed(!zoomed)}
      >
        <img
          src={mainImage}
          alt={`${productName} - view ${selectedIndex + 1}`}
          className={`w-full h-full object-cover object-top transition-transform duration-300 ${
            zoomed ? 'scale-150' : 'group-hover:scale-105'
          }`}
          loading="eager"
        />
        <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-600">
          {selectedIndex + 1} / {images.length}
        </div>
        {zoomed && (
          <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-background-50/90 backdrop-blur-sm rounded-full text-foreground-600 cursor-pointer">
            <i className="ri-zoom-out-line"></i>
          </div>
        )}
      </div>

      {/* Thumbnails */}
      <div className="flex gap-2 overflow-x-auto pb-1">
        {images.map((img, idx) => (
          <button
            key={idx}
            onClick={() => { setSelectedIndex(idx); setZoomed(false); }}
            className={`flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden transition-all duration-200 cursor-pointer ${
              idx === selectedIndex
                ? 'ring-2 ring-accent-500 ring-offset-2 ring-offset-background-50'
                : 'opacity-60 hover:opacity-100'
            }`}
            aria-label={`View ${productName} image ${idx + 1}`}
          >
            <img
              src={img}
              alt={`${productName} thumbnail ${idx + 1}`}
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </button>
        ))}
      </div>
    </div>
  );
}